import React, { Component } from 'react';
import MainStore from '../../../MainStore'
import ProjectSchedulleRow from './ProjectSchedulleRow'
import PeriodPicker from './PeriodPicker'
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export default class ProjectSchedulle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            viewType: 0
        };

        this.handleViewTypeChange = this.handleViewTypeChange.bind(this);
        this.load = this.load.bind(this);
        this.handlePeriodChange = this.handlePeriodChange.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    load(viewType, dates) {
        var scope = this;
        MainStore.setMaskVisible();
        fetch('api/Schedulle/Projects?viewType=' + (viewType === undefined ? this.state.viewType : viewType) + '&start=' + (dates ? dates.start.toISOString() : ''), {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ projects: result });
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    handleViewTypeChange = name => evt => {
        this.setState({ [name]: evt.target.value });
        this.load(evt.target.value);
    }

    handlePeriodChange(dates) {
        this.setState({ dates: dates });
        this.load(this.state.viewType, dates);
    }

    render() {
        return (
            <div style={{ overflowY: "auto", "paddingBottom": "50px" }}>
                <Select
                    value={this.state.viewType}
                    onChange={this.handleViewTypeChange('viewType')}
                >
                    <MenuItem value={0}>Неделя</MenuItem>
                    <MenuItem value={1}>Месяц</MenuItem>
                    <MenuItem value={2}>Год</MenuItem>
                    <MenuItem value={3}>Все время</MenuItem>
                </Select>
                <PeriodPicker viewType={this.state.viewType} onPeriodChange={this.handlePeriodChange}/>
                {this.state.projects.map(p => <div><ProjectSchedulleRow value={p} dates={this.state.dates} viewType={this.state.viewType}/><br/></div>)}
            </div>);
    }
}